import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import styles from './ReasonItem.scss'

import { sendTabClickSoundCommand, sendHoverSoundCommand } from 'react-wot-bootstrap'

const ReasonItem = ({ isChecked, onChange, reason = '' }) => (
    <label
        className={classNames(styles.base, isChecked && styles.isChecked)}
        onMouseDown={sendTabClickSoundCommand}
        onMouseEnter={sendHoverSoundCommand}
    >
        <input type="checkbox" className={styles.input} checked={isChecked} onChange={onChange} />
        <span className={styles.check} />
        <span className={styles.caption}>{reason}</span>
    </label>
)

ReasonItem.propTypes = {
    reason: PropTypes.node,
    isChecked: PropTypes.bool,
    onChange: PropTypes.func.isRequired,
}

export default ReasonItem



// WEBPACK FOOTER //
// ./containers/ClanLeaving/components/ReasonItem/ReasonItem.jsx